import React from 'react';
import styled, { keyframes } from 'styled-components';

interface ContainerProps {
  width?: string | number;
  height?: string | number;
  $backgroundColor?: string;
}

const wave = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const Container = styled.span<ContainerProps>`
  width: ${(props) =>
    typeof props.width === 'number'
      ? `${props.width}px`
      : props.width || 'auto'};
  height: ${(props) =>
    typeof props.height === 'number'
      ? `${props.height}px`
      : props.height || 'auto'};
  display: block;
  background-color: ${(props) => props.$backgroundColor};
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  &:after {
    inset: 0px;
    content: '';
    position: absolute;
    animation: 1s linear 1.3s infinite normal none running ${wave};
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      transparent,
      rgba(0, 0, 0, 0.1),
      transparent
    );
  }
`;

interface SkeletonWaveProps {
  // The width and height of the component.
  // Accepts either a string with units (e.g., '100vh', '10px') or a number (interpreted as pixels).
  // If not provided, it defaults to 'auto'.
  width?: string | number;
  height?: string | number;
  backgroundColor?: string;
}

const SkeletonWave: React.FC<SkeletonWaveProps> = ({
  width = 'auto',
  height = 'auto',
  backgroundColor = '#4B5360'
}: SkeletonWaveProps) => {
  return (
    <Container
      width={width}
      height={height}
      $backgroundColor={backgroundColor}
    />
  );
};

export default SkeletonWave;
